import { FragmentsOnCompositeTypesRule } from 'graphql';
import {
  GET_LIST_CHECKIN, GET_ORDER_DETAIL, GET_LIST_ORDER_HISTORY, GET_REPORT_CHECKIN, GET_LIST_TIME_KEEPING, GET_PAYROLL_LIST, GET_PAYROLL_SETTING, GET_DISCOUNT_SETTING,
  GET_INCOME_DETAIL, GET_APPROVE_PAYROLL, GET_TICKET_LIST, GET_BLOCK_LIST, GET_SALARY_CHART, GET_CASH_DISCOUNT_SETTING, GET_BATCH_HISTORY, GET_BATCH_DETAIL, GET_INCOME_HISTORY, CHANGE_DELETE_STATUS, CHANGE_ALL_DELETE_STATUS,
  CALCULATE_ORDER, CHECK_GIFTCARD, GET_STAFF_DAILY_INCOME
} from './goPosTypes'

export default {
  [GET_LIST_CHECKIN](state, data) {
    // state.customerList = data;
    if(data && data.items && data.items.length > 0) {
      let notDeleteNum = 0;
      for(let i = 0; i < data.items.length; i++) {
        data.items[i].delete_status = false;
        if(data.items[i].pos_status == 'cancelled' || data.items[i].pos_status == 'payment_success') {
        // if(data.items[i].pos_status == 'cancelled' || data.items[i].pos_status == 'payment_success' || data.items[i].pos_status == 'processing') {
          notDeleteNum++;
        }
      }
      if(notDeleteNum == data.items.length) {
        state.hasDeleteItem = false;
      } else {
        state.hasDeleteItem = true;
      }
    } else {
      state.hasDeleteItem = false;
    }
    state.isCheckAll = false;
    state.hasChecked = false;
    state.customerList = data;
  },
  [CHANGE_DELETE_STATUS](state, index) {
    let customerList = state.customerList;
    if(customerList.items && customerList.items[index]) {
      let status = customerList.items[index].delete_status ? false : true;
      customerList.items[index].delete_status = status;
      // if(!status) {
      //   state.isCheckAll = false;
      // } else {
      //   for(let i = 0; i < customerList.items.length; i++) {
      //     if(!customerList.items[i].delete_status) {
      //       state.isCheckAll = false;
      //       break;
      //     } else if(i == customerList.items.length - 1 && customerList.items[i].delete_status) {
      //       state.isCheckAll = true;
      //     }
      //   }
      // }
      let selectedNum = 0;
      let notDeleteNum = 0;
      for(let i = 0; i < customerList.items.length; i++) {
        if(customerList.items[i].pos_status == 'cancelled' || customerList.items[i].pos_status == 'payment_success') {
        // if(customerList.items[i].pos_status == 'cancelled' || customerList.items[i].pos_status == 'payment_success' || customerList.items[i].pos_status == 'processing') {
          notDeleteNum++;
        } else if(customerList.items[i].delete_status) {
          selectedNum++;
        }
      }

      if(selectedNum + notDeleteNum == customerList.items.length) {
        state.isCheckAll = true;
      } else {
        state.isCheckAll = false;
      }

      if(selectedNum > 0) {
        state.hasChecked = true;
      } else {
        state.hasChecked = false;
      }
    }
    state.customerList = customerList;
  },
  [CHANGE_ALL_DELETE_STATUS](state, status) {
    let customerList = state.customerList;
    if(customerList.items && customerList.items.length > 0) {
      for(let i = 0; i < customerList.items.length; i++) {
        customerList.items[i].delete_status = status;
        if(customerList.items[i].pos_status == 'cancelled' || customerList.items[i].pos_status == 'payment_success') {
        // if(customerList.items[i].pos_status == 'cancelled' || customerList.items[i].pos_status == 'payment_success' || customerList.items[i].pos_status == 'processing') {
          customerList.items[i].delete_status = false;
        }
      }
    }
    state.isCheckAll = status;
    state.hasChecked = status;
    state.customerList = customerList;
  },
  [GET_ORDER_DETAIL](state, data) {
    state.orderDetail = data;
  },
  [GET_LIST_ORDER_HISTORY](state, data) {
    state.historyOrderList = data;
  },
  [GET_REPORT_CHECKIN](state, data) {
    state.reportList = data;
  },
  [CALCULATE_ORDER](state, data) {
    state.calculatedOrder = data;
  },
  [CHECK_GIFTCARD](state, data) {
    state.checkedGiftCardData = data;
  },
  [GET_LIST_TIME_KEEPING](state, data) {
    state.timeKeepingList = data;
  },
  [GET_PAYROLL_LIST](state, data) {
    state.payrollData = data;
  },
  [GET_PAYROLL_SETTING](state, data) {
    state.payrollSetting = data;
  },
  [GET_DISCOUNT_SETTING](state, data) {
    state.discountSetting = data;
  },
  [GET_CASH_DISCOUNT_SETTING](state, data) {
    state.cashDiscountSetting = data;
  },
  [GET_INCOME_DETAIL](state, data) {
    state.incomeDetail = data;
  },
  [GET_APPROVE_PAYROLL](state, data) {
    state.approvePayrollData = data;
  },
  [GET_SALARY_CHART](state, data) {
    state.salaryChartData = data;
  },

  //ticket template
  [GET_TICKET_LIST](state, data) {
    state.ticketList = data;
  },
  [GET_BLOCK_LIST](state, data) {
    state.blockList = data;
  },

  //batch history
  [GET_BATCH_HISTORY](state, data) {
    state.batchHistory = data;
  },
  [GET_BATCH_DETAIL](state, data) {
    state.batchDetail = data;
  },

  //income history
  [GET_INCOME_HISTORY](state, data) {
    state.incomeHistory = data;
  },

  //staff daily income
  [GET_STAFF_DAILY_INCOME](state, data) {
    state.staffDailyIncome = data;
  }
}
